import { createClient } from 'react-fetching-library';
import _ from 'lodash';
import store from '../services/redux-store';
import id from 'date-fns/locale/id/index';

const requestHostInterceptor = host => client => action => ({
  ...action,
  endpoint: `${host}${action.endpoint}`
});

export const client = createClient({
  // eslint-disable-next-line no-undef
  requestInterceptors: [requestHostInterceptor(`${process.env.REACT_APP_API_URL}`)]
});

export const loginAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/login/',
  body

});

export const registerAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/register/',
  body

});

export const resetPasswordAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/reset-password/',
  body
});

export const resetPasswordCompleteAction = body => ({
  method: 'PATCH',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/reset-password/',
  body
});


export const generateReportAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'payments/generate_report/',
    body,
    responseType: 'blob'
  };
};

export const createTransactionAction = params => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/create_url_for_transaction/?${params}`
  };
};


export const uploadFormSchemaAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'forms/upload_form_schema/',
    body
  };
};

export const getFormListAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'forms/'
  };
};

export const getLatestFormAction = type => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `forms/get_latest_form/?form_type=${type}`
  };
};

export const getFormSectionsAction = id => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `forms/${id}/get_sections/`
  };
};

export const submitFormAction = (body, id) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: `forms/${id}/submit_form/`,
    body
  };
};


export const getDependsOnSeasonsAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_data/?${params}`
  };
};

export const getSeasonInitData = identifier => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_season_init_data/`
  };
};

export const getSeasonsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `?search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${search}`
  };
};

export const submitSeasonAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${id ? `${id}/` : ''}`
  };
};

export const getSeasonResorts = identifier => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${identifier}/get_season_resorts/`
  };
};

export const getPredefinedFilters = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/get_predefined_filters/?id=${id}`
  };
};

export const getResortsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `?search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/${search}`
  };
};

export const submitResortAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/${id ? `${id}/` : ''}`
  };
};

export const getCampsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/?season=${state.app.season}${search}`
  };
};

export const submitCampAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/${id ? `${id}/` : ''}`
  };
};

export const getEventsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `?search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${search}`
  };
};

export const submitEventAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${id ? `${id}/` : ''}`
  };
};

export const getAccomodationsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodations/?season=${state.app.season}${search}`
  };
};

export const submitAccomodationAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodations/${id ? `${id}/` : ''}`
  };
};

export const getAgeRangesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `age-ranges/?season=${state.app.season}${search}`
  };
};

export const submitAgeRangeAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `age-ranges/${id ? `${id}/` : ''}`
  };
};

export const getParticipantsAction = (page, pageSize, val) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `participants/?page=${page}&page_size=${pageSize}${search}`
  };
};

export const submitParticipantsAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `participants/${id ? `${id}/` : ''}`
  };
};


export const getPurchasersAction = (page, pageSize, val) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `purchasers/?page=${page}&page_size=${pageSize}${search}`
  };
};

export const submitPurchasersAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `purchasers/${id ? `${id}/` : ''}`
  };
};

export const getOrdersAction = (page, pageSize, val, sortingFields) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;
  const orderFilters = state.employeeOrderConfig.orderFilters[state.app.season];
  const searchFields = state.employeeOrderConfig.orderSearchFields;
  let ordering = '';

  if (sortingFields.length > 0) {
    ordering = '&ordering=';
    sortingFields.forEach((element, index) => {
      ordering += element;
      if ((index + 1) != sortingFields.length) {
        ordering += ',';
      }
    });
  }

  if (orderFilters === undefined) {
    return {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${state.app.token}`
      },
      endpoint: `orders/?page=${page}&page_size=${pageSize}${search}${ordering}&search_fields=${searchFields}`
    };
  }

  let filters = '';
  let camps = '';
  let resorts = '';
  let events = '';

  for (const element of orderFilters) {

    if (element === 'return_agreement') {
      filters += `&return_agreement=${true}`;
    }

    if (element === 'return_of_health_card') {
      filters += `&return_of_health_card=${true}`;
    }

    if (element === 'annex_return') {
      filters += `&annex_return=${true}`;
    }

    if (element === 'accommodated') {
      filters += `&accommodated=${true}`;
    }

    if (element === 'is_paid') {
      filters += `&is_paid=${true}`;
    }

    if (element === 'is_unpaid') {
      filters += `&is_unpaid=${true}`;
    }

    if (typeof element === 'object') {
      for (const property in element) {
        if (element[property] !== null) {
          filters += `&${property}=${element[property]}`;
        }
      }
    } else {
      if (element.startsWith('state')) {
        const state = element.split('-');
        filters += `&state=${state[1]}`;
      }

      if (element.startsWith('camp')) {
        const camp = element.split('-');
        if (camps.length === 0) {
          camps += camp[1];
        } else {
          camps += `,${camp[1]}`;
        }
      }

      if (element.startsWith('resort')) {
        const resort = element.split('-');
        if (resorts.length === 0) {
          resorts += resort[1];
        } else {
          resorts += `,${resort[1]}`;
        }
      }

      if (element.startsWith('event')) {
        const event = element.split('-');
        if (events.length === 0) {
          events += event[1];
        } else {
          events += `,${event[1]}`;
        }
      }
    }
  }

  if (camps.length > 0) {
    filters += `&camps=${camps}`;
  }

  if (resorts.length > 0) {
    filters += `&resorts=${resorts}`;
  }

  if (events.length > 0) {
    filters += `&events=${events}`;
  }

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/?page=${page}&page_size=${pageSize}${filters}${search}${ordering}&search_fields=${searchFields}`
  };
};

export const updateOrderAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/`,
    body
  };
};

export const deleteOrderAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/`
  };
};

export const duplicateOrderAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/duplicate/`
  };
};


export const getInvoiceDataAction = (id, type) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/get_invoice_data/?type=${type}`
  };
};

export const updateInvoiceNumberAction = (id, type, issue_date) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/update_invoice_number/?type=${type}&issue_date=${issue_date}`
  };
};

export const getPromotionsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/?season=${state.app.season}${search}`
  };
};

export const submitPromotionAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/${id ? `${id}/` : ''}`
  };
};

export const getPromotionPredefinedFilters = (id, title) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/get_predefined_filters/?season_id=${id}&title=${title}`
  };
};

export const getDocuments = (id, template_name, annex_id = 0) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/${id}/documents/?template_name=${template_name}&annex_id=${annex_id}`
  };
};

export const sendSetOfDocumentsAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/send_set_of_documents/`
  };
};

export const createAgreementAnnexAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/create_annex/`
  };
};

export const sendAgreementAnnexAction = (id, annex_id) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/send_annex/?annex_id=${annex_id}`
  };
};

export const getFormPromotionsAction = (identifier, params) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${identifier}/get_promotions/?${params}`
  };
};

export const getDependsOnEventAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/get_depends_on_action/?id=${id}`
  };
};

export const getDependsOnCampAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `camps/get_depends_on_data/?${params}`
  };
};


export const getDiscountAction = code => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `promotions/get_discount_action/?code=${code}`
  };
};


export const getTransportsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transports/?seasons=${state.app.season}${search}`
  };
};

export const submitTransportAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transports/${id ? `${id}/` : ''}`
  };
};

export const getModulesAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'modules/'
  };
};

export const getModuleViewsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `module-views/?module=${state.app.module}`
  };
};

export const submitModuleViewAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `module-views/${id ? `${id}/` : ''}`
  };
};

export const sendNotificationAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_custom_notification/',
    body
  };
};

export const sendNotificationsAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_custom_notifications/',
    body
  };
};

export const sendGroupNotificationAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_group_notification/',
    body
  };
};

export const getTemplateProductsAction = val => {
  const state = store.getState();
  let search = _.isNil(val) ? '?' : `?search=${val}&`;
  search += 'template=true';

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `products/${search}`
  };
};

export const submitProductAction = body => {
  const state = store.getState();

  return {
    body,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'products/'
  };
};

export const submitInvoiceAction = (body, method, id) => {
  const state = store.getState();

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `invoices/${id ? `${id}/` : ''}`,
    body
  };
};

export const getInvoiceDocuments = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `invoices/${id}/documents/`
  };
};

export const getDocumentsAction = val => {
  const state = store.getState();
  // const search = _.isNil(val) ? '' : `?search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `invoices/${val}`
  };
};

export const sendBankStatements = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'payments/bank_statements/'
  };
};

export const matchBankStatementsWithOrdersAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'orders/match_bank_statements_with_orders/'
  };
};


export const matchBankStatementsWithPaymentsAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'orders/match_bank_statements_with_payments/'
  };
};

export const getOrderFieldsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'orders/fields/'
  };
};

export const getSpreadsheetTemplate = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `spreadsheet-template/${id}/`
  };
};

export const getSpreadsheetTemplates = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'spreadsheet-template/'
  };
};

export const createSpreadsheetTemplate = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'spreadsheet-template/'
  };
};

export const updateSpreadsheetTemplate = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    body,
    endpoint: `spreadsheet-template/${id}/`
  };
};

export const deleteSpreadsheetTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `spreadsheet-template/${id}/`
  };
};


export const downloadSpreadsheet = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `spreadsheet-template/${id}/download_spreadsheet/`
  };
};

export const getNotificationSettingsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'notification-settings/?page_size=100'
  };
};

export const updateNotificationSettingsAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `notification-settings/${id}/`,
    body
  };
};

export const updateEmployeeConfigAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-configs/${id}/`
  };
};

export const getClientDataAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_data/'
  };
};

export const getClientKidsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_kids/'
  };
};

export const getClientOrdersAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_orders/'
  };
};

export const getClientPaymentsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_payments/'
  };
};

export const getEventStatisticsDataAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `events/get_statistics_data/?season=${state.app.season}`
  };
};

export const getTransportReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/transport_report/'
  };
};

export const getPromotionsReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/promotions_report/'
  };
};

export const getSeatAvailabilityReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: 'orders/seat_availability_report/'
  };
};

export const getListOfReceiptsReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/list_of_receipts/'
  };
};

export const getEndSalesReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/end_sales_statement/'
  };
};

export const senMessageWithUrlForTransaction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'orders/send_message_with_url_for_transaction/',
    body
  };
};

export const changeFormEventAction = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `events/${id ? id : 0}/change_form_event/`
  };
};

export const deleteProductAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `products/${id}/`
  };
};

export const updateProductAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `products/${id}/`,
    body
  };
};

export const addPositionsAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/add_positions/`
  };
};

export const duplicateEventAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `events/${id}/duplicate/`
  };
};

export const getResortInitData = identifier => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `resorts/get_init_data/?type=${identifier}`
  };
};

export const changeResortEventAction = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `resorts/${id ? id : 0}/change_form_resort/`
  };
};

export const createPaymentAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'payments/'
  };
};

export const updatePaymentAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/${id}/`,
    body
  };
};

export const getPaymentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/${id}/`
  };
};

export const sendPaymentReminder = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/${id}/send_payment_reminder/`
  };
};

export const deletePayment = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/${id}/`
  };
};


export const monthDay1Test = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'payments/month_day_1_test/'
  };
};

export const fineAndSendMailInfo = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: `payments/${id}/fine_and_send_mail/`
  };
};

export const monthDay1TestSendMails = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'payments/month_day_1_test_send_mails/'
  };
};

export const generateDeductions = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'payments/generate_deductions/'
  };
};

export const monthDay6Test = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${state.app.token}`
    },
    endpoint: 'payments/month_day_6_test/'
  };
};

export const getFormMetaDataAction = id => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'OPTIONS',
    headers,
    endpoint: `forms/${id}/`
  };
};

export const getHistoricDataByPeselAction = val => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/get_historic_data_by_pesel/?pesel=${val}`
  };
};
